import { render } from "./transaciton.vue?vue&type=template&id=4b9b0825&scoped=true"
import script from "./transaciton.vue?vue&type=script&lang=js"
export * from "./transaciton.vue?vue&type=script&lang=js"

import "./transaciton.vue?vue&type=style&index=0&id=4b9b0825&lang=scss&scoped=true"
import "./transaciton.vue?vue&type=style&index=1&id=4b9b0825&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9b0825"]])

export default __exports__